(()=>{
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine=window.matchMedia('(hover: hover) and (pointer: fine)');
  const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));
  function attachStage(el){
    if(el.dataset.v13Wired)return;
    el.dataset.v13Wired='true';
    const available=()=>!motion.matches || document.documentElement.classList.contains('v13-force-motion');
    const allowPointer=()=>available() && document.body?.dataset.v12Light!=='false';
    let raf=0,lastX=50,lastY=50;
    const update=()=>{
      raf=0;
      el.style.setProperty('--v13-px',lastX+'%');
      el.style.setProperty('--v13-py',lastY+'%');
      if(el.classList.contains('v13-hero')){
        const object=el.querySelector('[data-v13-parallax]');
        if(object){
          object.style.setProperty('--v13-tilt-x',((lastX-50)*.13).toFixed(2)+'px');
          object.style.setProperty('--v13-tilt-y',((lastY-50)*.11).toFixed(2)+'px');
          object.style.setProperty('--v13-cursor-x',lastX+'%');
          object.style.setProperty('--v13-cursor-y',lastY+'%');
        }
      }
    };
    const move=e=>{
      if(e.pointerType==='touch'||!allowPointer())return;
      const r=el.getBoundingClientRect();if(!r.width||!r.height)return;
      lastX=clamp((e.clientX-r.left)/r.width*100,0,100);
      lastY=clamp((e.clientY-r.top)/r.height*100,0,100);
      el.dataset.v13Active='true';
      if(!raf)raf=requestAnimationFrame(update);
    };
    const leave=()=>{
      el.dataset.v13Active='false';
      if(raf)cancelAnimationFrame(raf);
      raf=0;lastX=50;lastY=50;update();
    };
    el.addEventListener('pointermove',move,{passive:true});
    el.addEventListener('pointerleave',leave,{passive:true});
    fine.addEventListener?.('change',()=>{if(!allowPointer())leave()});
    motion.addEventListener?.('change',()=>{if(!allowPointer())leave()});
  }
  function attachGallery(root){
    if(root.dataset.v13GalleryReady)return;
    root.dataset.v13GalleryReady='true';
    const buttons=[...root.querySelectorAll('[data-v13-choice]')];
    const panels=[...root.querySelectorAll('[data-v13-panel]')];
    const progress=root.querySelector('[data-v13-gallery-progress]');
    const counter=root.querySelector('[data-v13-gallery-counter]');
    if(!buttons.length||!panels.length)return;
    const activate=i=>{
      const ids=buttons.map(b=>Number(b.dataset.v13Choice)).filter(id=>panels.some(p=>Number(p.dataset.v13Panel)===id));
      const selected=ids.includes(i)?i:ids[0];
      const index=ids.indexOf(selected);
      buttons.forEach((button,j)=>{
        const active=Number(button.dataset.v13Choice)===selected;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-pressed',String(active));
      });
      panels.forEach(panel=>{
        const active=Number(panel.dataset.v13Panel)===selected;
        panel.classList.toggle('is-active',active);
        panel.setAttribute('aria-hidden',String(!active));
        panel.querySelectorAll('a,button').forEach(control=>{control.tabIndex=active?0:-1});
      });
      if(progress)progress.style.transform='translateX('+(index*100)+'%)';
      if(counter)counter.textContent=String(index+1).padStart(2,'0')+' / '+String(ids.length).padStart(2,'0');
    };
    buttons.forEach(b=>{
      b.addEventListener('click',()=>activate(Number(b.dataset.v13Choice)));
      b.addEventListener('keydown',e=>{
        if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
        e.preventDefault();
        const ids=buttons.map(item=>Number(item.dataset.v13Choice)).filter(id=>panels.some(p=>Number(p.dataset.v13Panel)===id));
        const next=ids[(ids.indexOf(Number(b.dataset.v13Choice))+(e.key==='ArrowRight'?1:-1)+ids.length)%ids.length];
        activate(next);
        const target=buttons.find(item=>Number(item.dataset.v13Choice)===next);
        if(target)target.focus();
      });
    });
    const first=buttons.find(b=>b.classList.contains('is-active'));
    activate(first?Number(first.dataset.v13Choice):0);
  }
  function attachReveals(context){
    if(motion.matches&&!document.documentElement.classList.contains('v13-force-motion'))return;
    const items=[...context.querySelectorAll('[data-v13-reveal]')].filter(el=>!el.dataset.v13Seen);
    if(!items.length)return;
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        entry.target.dataset.v13Seen='true';
        entry.target.classList.add('v13-visible');
        observer.unobserve(entry.target);
      });
    },{threshold:.12,rootMargin:'0px 0px -25px 0px'});
    items.forEach(el=>observer.observe(el));
  }
  function init(context=document){
    context.querySelectorAll('[data-v13-stage]').forEach(attachStage);
    context.querySelectorAll('[data-v13-gallery]').forEach(attachGallery);
    attachReveals(context);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('buton:motion-change',()=>init(document));
  motion.addEventListener?.('change',()=>init(document));
})();
